import type { It4Response } from "@/shared/api";

import { stagePost } from "@/shared/api";

/** Конкретная модификация модели: память, цвет, характеристики ноутбука */
export interface DeviceProduct {
    brand_id: string;
    category: string;
    category_id: string;
    color: string;
    description: string;
    /** Процессор (для коммерческих ноутбуков) */
    keyShow2: string;
    /** Видеокарта */
    keyShow3: string;
    /** Оперативная память */
    keyShow4: string | null;
    /** Накопитель */
    keyShow5: string | null;
    model_id: string;
    productId: string;
    product_id: string;
    specialKey1: string | null;
    specialKey2: string | null;
    step4: string | null;
    step5: string | null;
    stepDesc4: string | null;
    stepDesc5: string | null;
    storage: string;
    subcategory: string;
    vendor: string;
}

/** Получить модификации модели */
export async function getDeviceProducts(payload: {
    token: string;
    model_id: string;
}): Promise<DeviceProduct[]> {
    const response = await stagePost<It4Response<DeviceProduct[]>>(
        "/api/tin/v1/site/quest/calc/products",
        payload,
    );
    return response.data;
}
